export default __webpack_public_path__ + "static/media/09en.6bd9507b.mp3";